import { actions } from '../constants/informationNote';
import * as actionTypes from '../../models/action/informationNote';
import { IAction } from '../../models/action/core';

import { Log } from 'ng2-logger';

const _logger = Log.create('InformationNote Add Page');
// #region Add InformationNote Action
export function addInformationNoteGetAction(data: actionTypes.IInformationNoteData, spinnerId?: string, spinnerType?: 'get'|'set', callback?: (value: boolean) => void): actionTypes.IGetAddInformationNote {
    return {
        InformationNoteData: data,
        timestamp: Date.now(),
        type: actions.ADD_INFORMATION_NOTE_ACTIVITY,
        spinnerId,
        spinnerType,
        callback
    };
}

// Add InformationNote Update Get Action
export function updateInformationNoteGetAction(
    dataParams: actionTypes.IInformationNoteParams,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IUpdateInformationNoteGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_INFORMATION_NOTE_UPDATE_ACTIVITY
    };
}

export function setInformationNoteDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_INFORMATION_NOTE_DATA_DEFAULT
    };
}

export function addInformationNoteSetAction(
    InformationNoteData: actionTypes.IInformationNoteData[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.ISetAddInformationNote {
    return {
        InformationNoteData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_INFORMATION_NOTE_SET_ACTIVITY
    };
}
// #endregion Add InformationNote Action

// #region Add InformationNote Action
export function deleteInformationNoteGetAction(data: actionTypes.IDeleteData): actionTypes.IGetDeleteInformationNote {
    return {
        InformationNoteData: data,
        timestamp: Date.now(),
        type: actions.DELETE_INFORMATION_NOTE_ACTIVITY
    };
}

export function deleteInformationNoteSetAction(deleteInformationNoteStatus: boolean): actionTypes.ISetDeleteInformationNote {
    return {
        deleteInformationNoteStatus,
        timestamp: Date.now(),
        type: actions.DELETE_INFORMATION_NOTE_SET_ACTIVITY
    };
}
// #endregion Add InformationNote Action

//#region InformationNote Pdf Page
export function saveInformationNotePdfPage(
    courseId: string,
    activityId: string,
    fileId: string,
    page: number,
    totalPage: number,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): any {
    return {
        courseId,
        activityId,
        page,
        totalPage,
        fileId,
        reset,
        timestamp: Date.now(),
        type: actions.SET_INFORMATION_NOTE_ACTIVITY_PDF_PAGE,
        spinnerId,
        spinnerType
    };
}
